import { render, staticRenderFns } from "./free-search.vue?vue&type=template&id=587e68cc&"
import script from "./free-search.vue?vue&type=script&lang=js&"
export * from "./free-search.vue?vue&type=script&lang=js&"
import style0 from "./free-search.vue?vue&type=style&index=0&id=587e68cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports